// extracted by mini-css-extract-plugin
module.exports = {"breadcrumbs":"index_breadcrumbs_368Cg","current":"index_current_2jw3G","arrow":"index_arrow_AzRHV"};